import classes from "./Slideshow.module.css";
import {Fragment, useEffect, useState} from "react";

const Slide_bistro = (props) =>{
    const [loadedSlides] = useState(props.slideshow || [])
    const [currentIndex, setCurrentIndex] = useState(0);
    const [, setroomsABCD] = useState(props.slideshowAD);
    const [, setroomsEF] = useState(props.slideshowEF);

    useEffect(() => {
        console.log('[Slide_bistro] Component mounted/updated', {
            slideshowLength: loadedSlides?.length,
            slideshow: loadedSlides,
            props: props
        });
        
        if (!loadedSlides || loadedSlides.length === 0) {
            console.warn('[Slide_bistro] No slides loaded!');
            return;
        }

        const intervalId = setInterval(() => {
            setCurrentIndex((prevIndex) => (prevIndex + 1) % loadedSlides.length);
        }, 15000);
        const hourDelay = 15 * 60 * 1000;
        const refreshPage = setTimeout(() => {
            window.location.reload();
        }, hourDelay);
        return () => {
            clearInterval(intervalId);
            clearTimeout(refreshPage);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loadedSlides.length]);

    if (!loadedSlides || loadedSlides.length === 0) {
        console.warn('[Slide_bistro] No slides to display');
        return <div>Loading...</div>;
    }

    let SlideShow_Bistro =(<div className={classes.slide}>
        <img
            src={loadedSlides[currentIndex]}
            alt={`Slide ${currentIndex + 1}`}
            className={`${classes.slideImage} ${classes.slideEl}`}
            onError={(e) => {
                console.error('[Slide_bistro] Image failed to load:', loadedSlides[currentIndex]);
                e.target.style.display = 'none';
            }}
            onLoad={() => {
                console.log('[Slide_bistro] Image loaded successfully:', loadedSlides[currentIndex]);
            }}
        />
    </div>)

    return (<Fragment>
        {SlideShow_Bistro}
    </Fragment>)
}

export default Slide_bistro